/**
 * Extract a user-facing message from lp-redux-api / fetch failures.
 * @param {object} error
 * @param {string} fallback
 * @returns {string}
 */
export function getLearningHubApiErrorMessage(error, fallback) {
  if (!error) return fallback
  if (typeof error.errorMessage === 'string' && error.errorMessage) {
    return error.errorMessage
  }
  if (typeof error.message === 'string' && error.message) {
    return error.message
  }
  const response = error.response
  if (response) {
    if (typeof response.message === 'string' && response.message) {
      return response.message
    }
    if (typeof response.errors === 'string' && response.errors) {
      return response.errors
    }
    if (Array.isArray(response.errors) && response.errors[0]) {
      return String(response.errors[0])
    }
  }
  if (typeof error.errors === 'string' && error.errors) {
    return error.errors
  }
  return fallback
}
